import api from './axiosConfig.js'

export const organizationApi = {
  // Super Admin - Organization Management
  listOrganizations: (params = {}) =>
    api.get('/organizations/organizations-list', { params }),

  getOrganizationDetails: (orgId) =>
    api.get('/organizations/organization', { params: { org_id: orgId } }),

  updateOrganization: (orgId, data) =>
    api.put('/organizations/organization', data, { params: { org_id: orgId } }),

  deleteOrganization: (orgId) =>
    api.delete('/organizations/organization', { params: { org_id: orgId } }),

  getOrgWeeklySummary: (orgId) =>
    api.get('/super-admin/org-weekly-summary', {
      params: { org_id: orgId },
      headers: { 'X-ORG-ID': orgId }
    }),


  // Org Admin - User Management
  getOrgUsers: () =>
    api.get('/users/org/users'),

  createOrgUser: (userData) =>
    api.post('/users/create/org/user', userData, { skipSuccessToast: true }),

  getUserDetails: (userId) =>
    api.get('/users/user/details', { params: { user_id: userId } }),

  updateUser: (userId, userData) =>
    api.put('/users/user/update', userData, { params: { user_id: userId }, skipSuccessToast: true }),

  deleteUser: (userId) =>
    api.delete('/users/user/delete', { params: { user_id: userId }, skipSuccessToast: true }),

  // Geofence — fetch org geofence config. orgId can be passed explicitly for QR scan (unauthenticated) flow.
  getOrgGeofenceInfo: (orgId = null) =>
    api.get('/employee/org/geofence-info', {
      skipErrorToast: true,
      ...(orgId ? { headers: { 'X-Org-ID': orgId } } : {})
    }),
}